import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  xmlns: "http://www.w3.org/2000/svg",
  width: "34.478",
  height: "34.478",
  viewBox: "0 0 34.478 34.478"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("clipPath", { id: "clip-path" }, [
  /*#__PURE__*/_createElementVNode("rect", {
    width: "34.478",
    height: "18.317",
    transform: "translate(0)",
    fill: "#fff"
  })
], -1)
const _hoisted_3 = ["id"]
const _hoisted_4 = ["stop-color"]
const _hoisted_5 = ["stop-color"]
const _hoisted_6 = ["stop-color"]
const _hoisted_7 = ["id"]
const _hoisted_8 = ["stop-color"]
const _hoisted_9 = ["stop-color"]
const _hoisted_10 = ["stop-color"]
const _hoisted_11 = ["fill"]
const _hoisted_12 = {
  key: 0,
  "clip-path": "url(#clip-path)"
}
const _hoisted_13 = ["fill"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_ctx.colors.length > 0)
    ? (_openBlock(), _createElementBlock("svg", _hoisted_1, [
        _createElementVNode("defs", null, [
          _hoisted_2,
          (_ctx.colors.length > 1)
            ? (_openBlock(), _createElementBlock("linearGradient", {
                key: 0,
                id: 'linear-gradient-1-' + _ctx.colorList[1],
                y1: "0.5",
                x2: "1",
                y2: "0.5",
                gradientUnits: "objectBoundingBox"
              }, [
                _createElementVNode("stop", {
                  offset: "0",
                  "stop-color": _ctx.rgbColors[_ctx.colorList[1]][0]
                }, null, 8, _hoisted_4),
                _createElementVNode("stop", {
                  offset: "0.199",
                  "stop-color": _ctx.rgbColors[_ctx.colorList[1]][1]
                }, null, 8, _hoisted_5),
                _createElementVNode("stop", {
                  offset: "0.959",
                  "stop-color": _ctx.rgbColors[_ctx.colorList[1]][2]
                }, null, 8, _hoisted_6)
              ], 8, _hoisted_3))
            : _createCommentVNode("", true),
          _createElementVNode("linearGradient", {
            id: 'linear-gradient-0-' + _ctx.colorList[0],
            y1: "0.5",
            x2: "1",
            y2: "0.5",
            gradientUnits: "objectBoundingBox"
          }, [
            _createElementVNode("stop", {
              offset: "0",
              "stop-color": _ctx.rgbColors[_ctx.colorList[0]][0]
            }, null, 8, _hoisted_8),
            _createElementVNode("stop", {
              offset: "0.498",
              "stop-color": _ctx.rgbColors[_ctx.colorList[0]][1]
            }, null, 8, _hoisted_9),
            _createElementVNode("stop", {
              offset: "1",
              "stop-color": _ctx.rgbColors[_ctx.colorList[0]][2]
            }, null, 8, _hoisted_10)
          ], 8, _hoisted_7)
        ]),
        _createElementVNode("rect", {
          id: "Rechteck_834",
          width: "34.478",
          height: "34.478",
          rx: "17.239",
          fill: 'url(#linear-gradient-0-' + _ctx.colorList[0] + ')'
        }, null, 8, _hoisted_11),
        (_ctx.colors.length > 1)
          ? (_openBlock(), _createElementBlock("g", _hoisted_12, [
              _createElementVNode("rect", {
                width: "34.478",
                height: "36.633",
                rx: "17.239",
                transform: "translate(0)",
                fill: 'url(#linear-gradient-1-' + _ctx.colorList[1] + ')'
              }, null, 8, _hoisted_13)
            ]))
          : _createCommentVNode("", true)
      ]))
    : _createCommentVNode("", true)
}